import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f843b2ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tiles"
}
const _hoisted_2 = { class: "tiles__grid" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "tile__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.tiles.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiles, (tile, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              href: tile.link,
              class: "tile",
              target: "_blank",
              rel: "noopener"
            }, [
              _createElementVNode("img", {
                class: "tile__image",
                src: tile.image && tile.image.medium,
                alt: tile.title,
                loading: "lazy"
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(tile.title), 1)
            ], 8, _hoisted_3))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}